import React, { useState, useEffect } from 'react'
import {
    getCommunityPersonalApi, getCommunityProfessionalApi, getDocumentDetailApi,
    getAddressDetailCommunityApi, getBankDetailCommunityApi, getChapterDetailsByChapterId,
    sendCompleteProfileLink, sendWelcomeMail, sendDocumentLink, saveUpdateDocumentApiOther, searchDocName
} from '../Community/CommunityActionCreator'
import Alerts from '../Popups/SidePopup'
import ButtonPopup from '../Popups/ButtonPopup'
import Loader from '../../../../presentationals/Loader/Loader.component'
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Tooltip from '@mui/material/Tooltip';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import DashboardAmuAgent from './DashboardAmuAgent'
import DealerMapping from './DealerMapping'
import DashboardAmuAgentnew from './DashboardAmuAgentnew'
const CommunityDetailMain = ({ Detaildata, handlePage }) => {
    const [objectData, setObjectData] = useState([])
    const [professionData, setprofessionData] = useState({})

    const [documentList, setDocumentList] = useState([])
    const [copyPopup, setcopyPopup] = useState(false)
    const [msg, setmsg] = useState()
    const [settingsPopup, setsettingsPopup] = useState(false)
    const [loaderState, setloaderState] = useState(false)
    const [viewPage, setViewPage] = useState('Basic')

    const [startingData, setStartingData] = useState({ file: '', description: '', docType: '', docName: '', docId: '' })

    const [otherDocumentUpload, setotherDocumentUpload] = useState(false)
    const [matchingData, setMatchingData] = useState([])
    const [matchingDiv, setMatchingDataDiv] = useState(false)
    const [objectDataOther, setObjectDataOther] = useState([])
    const [showPassword, setShowPassword] = useState(false)

    const [, updateState] = React.useState();
    const forceUpdate = React.useCallback(() => updateState({}), []);

    const [leadDetailData, setLeadDetailData] = useState({})



    useEffect(() => {
        console.log(Detaildata, "   rowwwww");
        if (Detaildata !== null && Detaildata !== undefined) {
            // if (location.state.page) {
            //     setViewPage(location.state.page)
            // }
            getPersonalDetailNew()
            getProfessionalDetail()

        }
    }, [])
    const OpenSettings = (type) => {
        if (type === 'open') {
            setsettingsPopup(true)
        }
        if (type === 'close') {
            setsettingsPopup(false)
        }
    }
    const getPersonalDetailNew = () => {
        getCommunityPersonalApi(Detaildata.communityId,
            callBack => {
                let changeObjectData = { objectData }
                changeObjectData = callBack?.data
                setObjectData(changeObjectData)
                getDocumentDetail(changeObjectData)
            }, error => {

            })
    }

    const getPersonalDetail = (oldData) => {
        // console.log(oldData)
        getCommunityPersonalApi(Detaildata.communityId,
            callBack => {
                let changeObjectData = { ...oldData, ...callBack.data }
                setObjectData(changeObjectData)
                getDocumentDetail(changeObjectData)
            }, error => {

            })
    }

    const getProfessionalDetail = () => {
        getCommunityProfessionalApi(Detaildata.communityId,
            callBack => {

                let changeObjectData = { ...callBack }
                setprofessionData(changeObjectData)
                getAddressDetail(changeObjectData)

            }, error => {

            })
    }

    const getAddressDetail = (oldData) => {
        // console.log(oldData)
        getAddressDetailCommunityApi(Detaildata.communityId,
            callBack => {
                if (callBack.length > 0) {
                    let changeObjectData = { ...oldData }
                    callBack.forEach(row => {
                        Object.keys(row).forEach(key => {
                            if (!key.includes('Perm')) {
                                if (row.addressType === "current") {
                                    changeObjectData[key] = row[key]
                                } else {
                                    changeObjectData[key + 'Perm'] = row[key]
                                }
                            }
                        })
                    })
                    changeObjectData = { ...changeObjectData, ...oldData }
                    setObjectData(changeObjectData)
                    getBankDetail(changeObjectData)
                } else {
                    getBankDetail(oldData)
                }
            }, error => {

            })
    }

    const getBankDetail = (oldData) => {
        getBankDetailCommunityApi(Detaildata.communityId,
            callBack => {
                let changeObjectData = { ...oldData, ...callBack }
                setObjectData(changeObjectData)
                getPersonalDetail(changeObjectData)
            }, error => {

            })

    }

    const getDocumentDetail = (data) => {
        getDocumentDetailApi(1, 10, data, callBack => {
            setDocumentList(callBack)
            if (callBack) {
                if (objectDataOther.length == 0) {
                    let changeStartingData = { file: '', description: '', docType: '', docName: 'Signed Agreement', docId: '' }
                    let changeStartingDataUnsigned = { file: '', description: '', docType: '', docName: 'Unsigned Agreement', docId: '' }
                    objectDataOther.push(changeStartingData)
                    objectDataOther.push(changeStartingDataUnsigned)
                    setObjectDataOther(objectDataOther)
                }

                callBack.map((data, i) => {
                    if (data.documentName === "Signed Agreement") {
                        objectDataOther[0].docId = data.documentId
                        objectDataOther[0].description = data.docDescription
                    }
                    else if (data.documentName === "Unsigned Agreement") {
                        objectDataOther[1].docId = data.documentId
                        objectDataOther[1].description = data.docDescription
                    }
                })
            }
        }, error => {

        })
    }

    const removePopup = () => {
        setTimeout(
            function () {
                setcopyPopup(false)
            }.bind(this),
            5000
        );
    }

    const sendLinkSubmit = (type) => {
        // console.log(type)
        if (type === 'profileComplete') {
            setloaderState(true)
            sendCompleteProfileLink(objectData.communityId, callBack => {
                // console.log(callBack)
                if (callBack && callBack.message === 'success') {
                    setloaderState(false)
                    setmsg('Mail Sent Successfully!')
                    setcopyPopup(true)
                    removePopup()

                } else {
                    setloaderState(false)
                    setmsg('Please try again later!')
                    setcopyPopup(true)
                    removePopup()
                }

            })
        }
        if (type === 'welcomeMail') {
            setloaderState(true)
            sendWelcomeMail(objectData.communityId, callBack => {
                // console.log(callBack)
                if (callBack && callBack.message === 'success') {
                    setloaderState(false)
                    setmsg('Mail Sent Successfully!')
                    setcopyPopup(true)
                    removePopup()

                } else {
                    setloaderState(false)
                    setmsg('Please try again later!')
                    setcopyPopup(true)
                    removePopup()
                }

            })
        }
        if (type === 'uploadDocument') {
            setloaderState(true)
            sendDocumentLink(objectData.communityId, callBack => {
                // console.log(callBack)
                if (callBack && callBack.message === 'success') {
                    setloaderState(false)
                    setmsg('Mail Sent Successfully!')
                    setcopyPopup(true)
                    removePopup()

                } else {
                    setloaderState(false)
                    setmsg('Please try again later!')
                    setcopyPopup(true)
                    removePopup()
                }

            })
        }

    }
    const backHandler = () => {
        handlePage("", "list")

    }
    const leadPageHandler = (type, data) => {
        if (type === 'addlead') {
            const obj = { communityId: objectData.communityId }
            handlePage(obj, "addcommunityLeadMain")
            // navigate(Routes.ADD_PERSONAL_LEADS, { state: { communityId: objectData.communityId, redirectTo: location.state ? location.state.redirectTo : null } })
        } else if (type === 'LeadDetails') {
            setViewPage(type)
            setLeadDetailData(data)
        } else {
            setViewPage(type)
        }

    }

    const uploadOtherOpen = () => {
        if (otherDocumentUpload === true) {
            setotherDocumentUpload(false)

        } else {
            setotherDocumentUpload(true)

        }
    }

    const mainActionHandler = (type, mainKey) => {
        if (type === 'mainAdd') {
            let changeStartingData = { ...startingData }
            objectDataOther[mainKey + 1] = changeStartingData
            setObjectDataOther(objectDataOther)
            setMatchingDataDiv(false)
            forceUpdate()
            // console.log(objectDataOther, "  objectDataOther");

        } else if (type === 'mainRemove') {
            setMatchingDataDiv(false)

            if (objectDataOther.length > 1 && objectDataOther[mainKey] !== undefined) {
                if (objectDataOther[mainKey].id !== undefined && objectDataOther[mainKey].id !== null && objectDataOther[mainKey].id !== '') {
                } else {
                    objectDataOther.splice(mainKey, 1)
                    setObjectDataOther(objectDataOther)
                    forceUpdate()
                }
            }
        }
    }
    const descriptionHandler = (e, type, key) => {
        let changeObjectData = { ...objectDataOther[key] }
        changeObjectData[type] = e
        objectDataOther[key] = changeObjectData
        setObjectData(changeObjectData)
        if (type === 'docName') {
            if (e) {
                searchDocName(e, callBack => {
                    setMatchingData(callBack.data)
                    setMatchingDataDiv(key)
                })
            } else {
                setMatchingDataDiv(false)

            }
        }
    }

    const otherDocumentHandler = (e, id) => {

        if (e.target.files[0]) {
            setloaderState(true)
            let replaceOrUpload = 0
            if (objectDataOther[id].docName === "Signed Agreement" || objectDataOther[id].docName === "Unsigned Agreement") {
                if (objectDataOther[id].docId) {
                    replaceOrUpload = 1
                }
            }
            saveUpdateDocumentApiOther(e.target.files[0], objectDataOther[id].docName, objectDataOther[id].docId, Detaildata, objectDataOther[id].description, replaceOrUpload
                , callBack => {
                    setloaderState(false)
                    getPersonalDetailNew()
                },
                error => {
                    setloaderState(false)
                })

        }
    }
    // const getUploadedDocuments = (data) => {
    //     getUploadedDocumentsApi(location.state.rowData.userId, callBack => {
    //         setDocumentList(callBack)
    //     })
    // }

    const docNameHandler = (data, type, key) => {
        let changeObjectData = { ...objectDataOther[key] }
        changeObjectData['docName'] = data.doc_name
        changeObjectData['documentId'] = data.document_id
        objectDataOther[key] = changeObjectData
        setObjectData(changeObjectData)
        setMatchingDataDiv('')

    }

    const handlePasswordView = () => {
        setShowPassword(!showPassword)
    }




    return (
        <>

            <div className='container-fluid'>
                {loaderState ?
                    <Loader />
                    : ""}
            

                            <Tooltip title="Back">
                                <ArrowBackIcon onClick={e => backHandler()} style={{ marginBottom: '15px', color: '#000', cursor: 'pointer', fontSize: '24px' }} />
                            </Tooltip>
                            {!settingsPopup ?
                                <div className='page-wrapper' onClick={() => OpenSettings('open')} style={{ background: 'transparent', top: '14%' }}>
                                    <i className='fa fa-bars'></i>
                                </div>
                                : ""}
                            {settingsPopup ?
                                <ButtonPopup sendLinkSubmit={sendLinkSubmit} OpenSettings={OpenSettings} />
                                : ""}
                            <div className='row' style={{ marginBottom: '20px' }}>
                                <div className="edit-profile-menu col-xs-12">
                                    <div className="btn-group-tab">
                                        <div>
                                            <button className={viewPage === 'Basic' ? 'active' : ''} onClick={e => leadPageHandler('Basic', "")} >Basic Details</button>
                                        </div>
                                        <div>
                                            <button className={viewPage === 'dashboard' ? 'active' : ''} onClick={e => leadPageHandler('dashboard', "")} >Dashboard</button>
                                        </div>
                                        <div>
                                            <button className={viewPage === 'dealerMapping' ? 'active' : ''} onClick={e => leadPageHandler('dealerMapping', "")} >Dealer</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        
                {viewPage === 'Basic' ?
                    <div className='row'>

                        <div className="col-sm-6 col-xs-12 mt-2">
                            <div className="profile-details-box-new" style={{ minHeight: '300px' }}>
                                <div className="new-basic-head" > Personal Details</div>
                                <div style={{ padding: '10px' }}>
                                    <div className='row' >
                                        <div className='col-sm-2 col-xs-12'>
                                            <label className='' style={{ fontSize: '15px', fontWeight: "400" }}>Name</label>
                                        </div>
                                        <div className='col-sm-4 col-xs-12'>
                                            <div style={{ fontSize: '15px' }}> <b>{objectData.name}</b></div>
                                        </div>
                                        <div className='col-sm-2 col-xs-12'>
                                            <label className='' style={{ fontSize: '15px', fontWeight: "400" }}>Mobile No
                                            </label>
                                        </div>
                                        <div className='col-sm-4 col-xs-12'>
                                            <div style={{ fontSize: '15px' }}> <b>{objectData.mobileNumber}</b></div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-sm-2 col-xs-12'>
                                            <label className='' style={{ fontSize: '15px', fontWeight: "400" }}>Email Id
                                            </label>
                                        </div>
                                        <div className='col-sm-4 col-xs-12'>

                                            <div style={{ fontSize: '15px' }}> <b>{objectData.email}</b></div>
                                        </div>
                                        <div className='col-sm-2 col-xs-12'>
                                            <label className='' style={{ fontSize: '15px', fontWeight: "400" }}>Aadhaar No
                                            </label>
                                        </div>
                                        <div className='col-sm-4 col-xs-12'>
                                            <div style={{ fontSize: '15px' }}> <b>{objectData.aadhaarNo}</b></div>
                                        </div>
                                    </div>
                                    <div className='row'>

                                        <div className='col-sm-2 col-xs-12'>
                                            <label className='' style={{ fontSize: '15px', fontWeight: "400" }}>Pan No</label>
                                        </div>
                                        <div className='col-sm-4 col-xs-12'>
                                            <div style={{ fontSize: '15px' }}> <b>{objectData.panNumber}</b></div>
                                        </div>
                                        <div className='col-sm-2 col-xs-12'>
                                            <label className='' style={{ fontSize: '15px', fontWeight: "400" }}>Name on PAN</label>
                                        </div>
                                        <div className='col-sm-4 col-xs-12'>
                                            <div style={{ fontSize: '15px' }}> <b>{objectData.nameOnPan}</b></div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-sm-2 col-xs-12'>
                                            <label className='' style={{ fontSize: '15px', fontWeight: "400" }}>App Status</label>
                                        </div>
                                        <div className='col-sm-4 col-xs-12'>
                                            <div style={{ fontSize: '15px' }}> <b>{objectData.appDownloadStatus ? <b className='text-success'>Installed</b> : <b className='text-danger'>Not Installed</b>}</b></div>
                                        </div>
                                        <div className='col-sm-2 col-xs-12'>
                                            <label className='' style={{ fontSize: '15px', fontWeight: "400" }}>Password</label>
                                        </div>
                                        <div className='col-sm-4 col-xs-12'>
                                            {/* <div style={{ fontSize: '15px',display:'flex',alignItems:"center" }}> <b>{objectData?.password}</b> &nbsp;&nbsp; {!showPassword ? <VisibilityIcon onClick={()=>handlePasswordView()}/> : <VisibilityOffIcon onClick={()=>handlePasswordView()}/>}</div> */}
                                            <div style={{ fontSize: '15px', display: 'flex', alignItems: "center" }}> <input style={{ background: '#fff' }} value={objectData?.password} type={showPassword ? "text" : "password"} disabled={true} /> &nbsp;&nbsp; {!showPassword ? <VisibilityIcon onClick={() => handlePasswordView()} style={{ cursor: "pointer" }} /> : <VisibilityOffIcon onClick={() => handlePasswordView()} style={{ cursor: "pointer" }} />}</div>
                                        </div>
                                    </div>

                                    {objectData.referenceName ?
                                        <div className='row' >
                                            <div className='col-sm-3 col-xs-12'>
                                                <label className='' style={{ fontSize: '15px', fontWeight: "400" }}>Reference Name </label>
                                            </div>
                                            <div className='col-sm-4 col-xs-12'>
                                                <div style={{ fontSize: '15px' }}> <b>{objectData.referenceName}</b></div>
                                            </div>

                                        </div>
                                        : ""}
                                    <div className='row'>
                                        {objectData.firmName ?
                                            <div className='col-sm-2 col-xs-12'>
                                                <label className='' style={{ fontSize: '15px', fontWeight: "400" }}>Company Name </label>
                                            </div>
                                            : ""}
                                        {objectData.firmName ?
                                            <div className='col-sm-4 col-xs-12'>
                                                <div style={{ fontSize: '15px' }}> <b>{objectData.firmName}</b></div>
                                            </div>
                                            : ""}
                                        {/* <div className='col-sm-2 col-xs-12'>
                                    <label className='' style={{ fontSize: '15px' }}>Company Income</label>
                                </div>
                                <div className='col-sm-4 col-xs-12'>
                                    <div style={{ fontSize: '15px' }}> <b>{objectData.companyNetIncomeAnnual}</b></div>
                                </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 col-xs-12 mt-2">
                            <div className="profile-details-box-new" style={{ minHeight: '300px' }}>
                                <div className="new-basic-head" > Professional Details</div>
                                <div style={{ padding: '10px' }}>
                                    <div className='row' >
                                        <div className="col-sm-3 col-xs-12">
                                            <div className="d-flex" style={{ marginTop: '20px' }}>
                                                Firm Name  &nbsp;&nbsp;&nbsp;
                                                <b style={{}}>{professionData ? professionData.firmName : ""}</b>
                                            </div>
                                        </div>
                                        <div className="col-sm-3 col-xs-12">
                                            <div className="d-flex" style={{ marginTop: '20px' }}>
                                                GSTIN &nbsp;&nbsp;&nbsp;
                                                <b style={{}}>{professionData ? professionData.gstNumber : ""}</b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {objectData && objectData.address ?
                            <div className="col-sm-6 col-xs-12 mt-2">
                                <div className="profile-details-box-new" style={{ minHeight: '300px' }}>
                                    <div className="new-basic-head" > Current Address</div>
                                    <div style={{ padding: '10px' }}>
                                        <div className='row'>
                                            <div className='col-sm-2 col-xs-12'>
                                                <label style={{ fontSize: '15px', fontWeight: "400" }}>Address</label>
                                            </div>
                                            <div className='col-sm-4 col-xs-12'>
                                                <div style={{ fontSize: '15px' }}> <b>{objectData.address}</b></div>
                                            </div>
                                            <div className='col-sm-2 col-xs-12'>
                                                <label style={{ fontSize: '15px', fontWeight: "400" }}>City</label>
                                            </div>
                                            <div className='col-sm-4 col-xs-12'>
                                                <div style={{ fontSize: '15px' }}> <b>{objectData.city}</b></div>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-sm-2 col-xs-12'>
                                                <label style={{ fontSize: '15px', fontWeight: "400" }}>State</label>
                                            </div>
                                            <div className='col-sm-4 col-xs-12'>
                                                <div style={{ fontSize: '15px' }}> <b>{objectData.state}</b></div>
                                            </div>
                                            <div className='col-sm-2 col-xs-12'>
                                                <label style={{ fontSize: '15px', fontWeight: "400" }}>Pincode</label>
                                            </div>
                                            <div className='col-sm-4 col-xs-12'>
                                                <div style={{ fontSize: '15px' }}> <b>{objectData.pincode}</b></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : ""}
                        {objectData && objectData.addressPerm ?
                            <div className="col-sm-6 col-xs-12 mt-2">
                                <div className="profile-details-box-new" style={{ minHeight: '300px' }}>
                                    <div className="new-basic-head" > Permanent Address</div>
                                    <div style={{ padding: '10px' }}>
                                        <div className='row'>
                                            <div className='col-xs-12 col-sm-2'>
                                                <label style={{ fontSize: '15px', fontWeight: "400" }}>Address</label>
                                            </div>
                                            <div className='col-sm-4 col-xs-12'>
                                                <div style={{ fontSize: '15px' }}> <b>{objectData.addressPerm}</b></div>
                                            </div>
                                            <div className='col-xs-12 col-sm-2'>
                                                <label style={{ fontSize: '15px', fontWeight: "400" }}>City</label>
                                            </div>
                                            <div className='col-sm-4 col-xs-12'>
                                                <div style={{ fontSize: '15px' }}> <b>{objectData.cityPerm}</b></div>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-xs-12 col-sm-2'>
                                                <label style={{ fontSize: '15px', fontWeight: "400" }}>State</label>
                                            </div>
                                            <div className='col-sm-4 col-xs-12'>
                                                <div style={{ fontSize: '15px' }}> <b>{objectData.statePerm}</b></div>
                                            </div>
                                            <div className='col-xs-12 col-sm-2'>
                                                <label style={{ fontSize: '15px', fontWeight: "400" }}>Pincode</label>
                                            </div>
                                            <div className='col-sm-4 col-xs-12'>
                                                <div style={{ fontSize: '15px' }}> <b>{objectData.pincodePerm}</b></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : ""}
                        {objectData && objectData.accNumber ?
                            <div className="col-sm-6 col-xs-12 mt-2">
                                <div className="profile-details-box-new" style={{ minHeight: '300px' }}>
                                    <div className="new-basic-head" > Bank Details</div>
                                    <div style={{ padding: '10px' }}>
                                        <div className='row'>
                                            <div className='col-sm-2 col-xs-12'>
                                                <label className='' style={{ fontSize: '15px', fontWeight: "400" }}>Acc Number</label>
                                            </div>
                                            <div className='col-sm-4 col-xs-12'>
                                                <div style={{ fontSize: '15px' }}> <b>{objectData.accNumber}</b></div>
                                            </div>
                                            <div className='col-sm-2 col-xs-12'>
                                                <label className='' style={{ fontSize: '15px', fontWeight: "400" }}>Bank Name</label>
                                            </div>
                                            <div className='col-sm-4 col-xs-12'>
                                                <div style={{ fontSize: '15px' }}> <b>{objectData.bank}</b></div>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-sm-2 col-xs-12'>
                                                <label className='' style={{ fontSize: '15px', fontWeight: "400" }}>Branch</label>
                                            </div>
                                            <div className='col-sm-4 col-xs-12'>
                                                <div style={{ fontSize: '15px' }}> <b>{objectData.branch}</b></div>
                                            </div>
                                            <div className='col-sm-2 col-xs-12'>
                                                <label className='' style={{ fontSize: '15px', fontWeight: "400" }}>IFSC</label>

                                            </div>
                                            <div className='col-sm-4 col-xs-12'>
                                                <div style={{ fontSize: '15px' }}> <b>{objectData.ifsc}</b></div>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className='col-sm-2 col-xs-12'>
                                                <label className='' style={{ fontSize: '15px', fontWeight: "400" }}>Name in bank</label>
                                            </div>
                                            <div className='col-sm-4 col-xs-12'>
                                                <div style={{ fontSize: '15px' }}> <b>{objectData.nameInBank}</b></div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            : ""}
                    </div>
                    : ""}

                    {
                        viewPage === "dashboard" ? 
                        // <DashboardAmuAgent communityId={Detaildata.communityId} handlePage={handlePage} />
                        <DashboardAmuAgentnew communityId={Detaildata.communityId} handlePage={handlePage} />
                        :''
                    }
                    {
                        viewPage === "dealerMapping" ? 
                        <DealerMapping ParentcommunityId={Detaildata.communityId} handlePage={handlePage} />
                        :''
                    }


            </div>

        </>
        // </div>
    )
}

export default CommunityDetailMain;
